
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { NextSeo } from "@components/seo";
import parse from "html-react-parser";
import type { GetStaticProps, NextPage } from "next/types";
import { PAGE } from "../consts/ppages";
import { getPageById } from "../utils/get-page";
interface IPage {
    page: {
        title: string;
        content: string;
    };
}
const InstallerGuide: NextPage<IPage> = ({ page }) => (<>
    <NextSeo languageAlternates={[
        { href: "https://knsokna.pl/installer-guide", hrefLang: "x-default" },
        { href: "https://knswindows.com/installer-guide", hrefLang: "en" },
        { href: "https://knsokna.pl/installer-guide", hrefLang: "pl" },
        { href: "https://knsfenster.de/installer-guide", hrefLang: "de" },
        { href: "https://kns-okna.eu/installer-guide", hrefLang: "cs" },
        { href: "https://knsfinestre.it/installer-guide", hrefLang: "it" },
        { href: "https://knsfenetres.fr/installer-guide", hrefLang: "fr" },
        { href: "https://knsokna.eu/installer-guide", hrefLang: "hu" },
    ]}/>
    <div className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div>{parse(page?.content || "")}</div>
      </div>
    </div>
  </>);
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || "PL";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const PAGE_ID = PAGE.INSTALLER[LOCALE as keyof typeof PAGE.INSTALLER] || 1;
    const { page } = await getPageById(PAGE_ID);
    return {
        props: {
            page,
        },
    };
};
export default InstallerGuide;

    async function __Next_Translate__getStaticProps__1a19cd2beda__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/installer-guide',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2beda__ as getStaticProps }
  